import { getCreditNoteById } from '@/api/billing/credit-notes'
import { queryOptions } from "@tanstack/vue-query";
import { type MaybeRefOrGetter, toValue } from 'vue'

export namespace queryKeys {
  export namespace creditNotes {
    export function all(): readonly ['credit-notes']
    export function all() {
      return ['credit-notes'] as const
    }

    export function detail(id: MaybeRefOrGetter<number>) {
      return [...all(), toValue(id)] as const
    }
  }

  export namespace creditNotesBackend {
    export function all(): readonly ['credit-notes-backend']
    export function all() {
      return ['credit-notes-backend'] as const
    }

    export function detail(id: MaybeRefOrGetter<number>) {
      return [...all(), toValue(id)] as const
    }
  }
}

export const fetchCreditNoteQueryOptions = (creditNoteId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['credit-notes', creditNoteId],
  queryFn: () => getCreditNoteById(toValue(creditNoteId))
})